require('../vendor/stacktable/stacktable.js');

$(document).ready(function() {
    // get table
    $('.u-content table').each(function() {
        // this creates the new table
        // hide / show with css .convert-table-on-mobile
        $(this).stacktable();

        // make sure full width, for max space on text
        if (window.innerWidth < 768) {
            console.log('width < 768');
            $(this).width('100%');
        }
    });
});